import { useQuery } from '@tanstack/react-query';
import { IGetRecommendedProfessionalsParams } from '../recommendedProfessionalsApi';
import { recommendedProfessionalsService } from '../recommendedProfessionalsService';
import { IRecommendedProfessional } from '../recommendedProfessionalsTypes';

type TUseRecommendedProfessionalsParams = IGetRecommendedProfessionalsParams & {
  enabled: boolean;
};

export function useRecommendedProfessionals(params: TUseRecommendedProfessionalsParams) {
  return useQuery<IRecommendedProfessional[]>({
    queryKey: ['recommended-professionals', params],
    queryFn: () => recommendedProfessionalsService.getRecommendedProfessionals(params),
    enabled: params.enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });
}
